module.exports = __webpack_public_path__ + "img/no-picture.0790fe9f.png";